<template>
  <div id="app" class="antialiased">
    <router-view></router-view>
  </div>
</template>

<script>
import '@/assets/styles/font.css'
export default {
  name: 'app'
}
</script>
<style lang="scss">
html, body {
  font-family: 'Figtree-Medium', sans-serif;
}
.font-regular {
  font-family: 'Figtree-Medium', sans-serif;
}
.font-semibold {
  font-family: 'Figtree-SemiBold', sans-serif;
}
::-webkit-scrollbar {
    width: 06px;
    height: 6px;
}
::-webkit-scrollbar-track {
    background: #dae1e7;
    border-radius: 0px;
}
::-webkit-scrollbar-thumb {
    background: #b4babe;
    border-radius: 0px;
}

a {
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/App.vue